// The direct answer, rendered first. The same text is exported to llms.txt /
// llms-full.txt by scripts/generate-llms.mjs, so what an answer engine quotes
// is exactly what a reader sees.
const TLDR = ({ text }: { text: string }) => (
  <section aria-labelledby="tldr-heading" className="border border-forest bg-cream-light px-6 py-6 md:px-8">
    <h2 id="tldr-heading" className="label mb-3">
      TL;DR
    </h2>
    <p className="text-lead">{text}</p>
  </section>
);

export default TLDR;
